import * as types from "./../types";

const initState = {
  cityList: null,
  bancaCityList: null,
  companyList: null,
  designationList: null,
  bankList: null,
  branchList: null,
  cityListByPin: null,
  error: null,
  appTheme: null,
  disabilityList: null,
};


// const compList = [
//   {
//     "cmpNm": "TATA CONSULTANCY SERVICES LTD",
//     "companyAlias": "TATA CONSULTANCY SERVICES LTD",
//     "natureOfCompany": "A"
//   },
//   {
//     "cmpNm": "SBI CARDS AND PAYMENT SERVICES LIMITED",
//     "companyAlias": "SBICARDS AND PAYMENT SERVICES LIMITED",
//     "natureOfCompany": "A"
//   }
// ];

// const desigList = ["DIRECTOR", "MANAGER"];


const MasterDataReducer = (state = initState, actions) => {
  switch (actions.type) {
    case types.GET_MASTER_DATA:
      return {
        ...state,
        // cityList: actions.payload.eapplyMasterDataRsType?.cityList,
        bancaCityList: actions.payload.eapplyMasterDataRsType?.bancaCityList,
        companyList: actions.payload.eapplyMasterDataRsType.companyList ? actions.payload.eapplyMasterDataRsType.companyList : undefined,
        designationList: actions.payload.eapplyMasterDataRsType?.designationList ? actions.payload.eapplyMasterDataRsType?.designationList : undefined,
        // error: actions.statusCode,
        // error: actions.error,
      };
    case types.GET_CITY_DATA:
      return {
        ...state,
        cityList: actions.payload.eapplyMasterDataRsType?.cityList ? actions.payload.eapplyMasterDataRsType?.cityList : undefined,
      };
    case types.GET_BANK_LIST_DATA:
      return {
        ...state,
        bankList: actions.payload.eapplyMasterDataRsType?.bankListResponse?.bankList ? actions.payload.eapplyMasterDataRsType?.bankListResponse?.bankList : undefined,
      };
    case types.GET_IFSC_CODE_DATA:
      return {
        ...state,
        branchList: actions.payload.eapplyMasterDataRsType?.branchListResponse?.branchList,
      };
    case types.GET_CITY_DATA_BY_PIN:
        return {
          ...state,
        cityListByPin: actions.payload.eapplyMasterDataRsType?.pincodeList ? actions.payload.eapplyMasterDataRsType?.pincodeList : undefined, 
      }; 
      case types.SAVE_VAL_ERROR_MS:
        return {
          ...state,
          error: actions.payload ? actions.payload : null ,
      };   
      case types.APP_THEME_DATA:
      return {
        ...state,
        appTheme: actions.payload ? actions.payload : null ,
      };
      case types.LOCAL_DISABILITY_LIST:
            return{
                ...state,
                disabilityList : actions.payload ? actions.payload : null ,
            }
    default:
      return state;
  }
};

export default MasterDataReducer;
